"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StepNotFoundError_1 = require("../Error/StepNotFoundError");
/**
 * Factory for widget step.
 */
class WidgetStepFactory {
    /**
     * Constructs widget step factory.
     *
     * @param {WidgetStepPluginManager} stepPluginManager
     */
    constructor(stepPluginManager) {
        this.stepPluginManager = stepPluginManager;
    }
    /**
     * Creates step from index.
     *
     * Index should be from 1 to infinite. Note that only linear steps
     * can be created with this method.
     *
     * @see WidgetStepPluginDefinition
     *
     * @param {number} index
     * @param {WidgetConfig} config
     * @param {WidgetState} state
     * @param {EventContainerContext} eventContext
     * @return {WidgetStepPlugin}
     */
    createFromIndex(index, config, state, eventContext) {
        const definitions = this.stepPluginManager.getDefinitions()
            .filter((def) => def.isLinear());
        if (!definitions[index - 1]) {
            throw new StepNotFoundError_1.default(`Step with index ${index} does not exist.`);
        }
        return this.createFromId(definitions[index - 1].getId(), config, state, eventContext);
    }
    /**
     * Create step from id.
     *
     * @param {string} id
     * @param {WidgetConfig} config
     * @param {WidgetState} state
     * @param {EventContainerContext} eventContext
     * @return {WidgetStepPlugin}
     */
    createFromId(id, config, state, eventContext) {
        return this.stepPluginManager.create(id, config, state, eventContext);
    }
}
exports.default = WidgetStepFactory;
